import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import CardPaper from './CardPaper'
import { IconButton, Label } from '../default'
import { CreatePlanModal, InsertPlanModal, CreatePlanTableModal, ManagePlanTableModal } from '../modal'
import { useHistory } from 'react-router-dom'
import { ROUTER } from '../../class/constants'
import { Add, MoveToInbox, PlaylistAdd, TableChart } from '@material-ui/icons'

const PLAN_MODALS = {
  CREATE: 1,
  INSERT: 2,
  CREATE_TABLE: 3,
  MANAGE_TABLE: 4
}

function CardPlan({
  classes
}) {
  const { t } = useTranslation()
  const history = useHistory()

  const [currentModal, setCurrentModal] = useState(null)

  const loadCreatePlanModal = () => {
    setCurrentModal(PLAN_MODALS.CREATE)
  }

  const loadInsertPlanModal = () => {
    setCurrentModal(PLAN_MODALS.INSERT)
  }

  const loadCreatePlanTableModal = () => {
    setCurrentModal(PLAN_MODALS.CREATE_TABLE)
  }

  const loadManagePlanTableModal = () => {
    setCurrentModal(PLAN_MODALS.MANAGE_TABLE)
  }

  const loadAddUserToPlanTable = () => {
    return history.push({
      pathname: ROUTER.CUSTOMER_PLAN_TABLE.SEARCH
    })
  }

  return (
    <div className={classes.form}>

      <CreatePlanModal
        onClose={() => setCurrentModal(null)}
        open={currentModal === PLAN_MODALS.CREATE}
      />
      <InsertPlanModal
        onClose={() => setCurrentModal(null)}
        open={currentModal === PLAN_MODALS.INSERT}
      />
      <CreatePlanTableModal
        onClose={() => setCurrentModal(null)}
        open={currentModal === PLAN_MODALS.CREATE_TABLE}
      />
      {/** V3 */}
      <ManagePlanTableModal
        onClose={() => setCurrentModal(null)}
        open={currentModal === PLAN_MODALS.MANAGE_TABLE}
      />

      <Grid container spacing={3}>

        <Grid item xs={12} sm={6} xl={3} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadCreatePlanModal}
              icon={Add}
            >
              {t('cards.plans.btnCreatePlan')}
            </IconButton>
          </CardPaper>
        </Grid>

        <Grid item xs={12} sm={6} xl={3} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadAddUserToPlanTable}
              icon={MoveToInbox}
            >
              {t('cards.plans.btnAddUserToPlanTable')}
            </IconButton>
          </CardPaper>
        </Grid>

        <Grid item xs={12}>
          <hr />
        </Grid>

        <Grid item xs={12}>
          <Label v='h6' bold>{t('cards.plans.v3')}</Label>
        </Grid>

        <Grid item xs={12} sm={6} xl={3} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadManagePlanTableModal}
              icon={TableChart}
            >
              {t('cards.plans.btnManagePlanTable')}
            </IconButton>
          </CardPaper>
        </Grid>

        <Grid item xs={12}>
          <hr />
        </Grid>

        <Grid item xs={12}>
          <Label v='h6' bold>{t('cards.plans.legacy')}</Label>
        </Grid>

        <Grid item xs={12} sm={6} xl={3} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadCreatePlanTableModal}
              icon={TableChart}
              style={{ backgroundColor: '#555555' }}
            >
              {t('cards.plans.btnCreatePlanTableLegacy')}
            </IconButton>
          </CardPaper>
        </Grid>

        <Grid item xs={12} sm={6} xl={3} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadInsertPlanModal}
              icon={PlaylistAdd}
              style={{ backgroundColor: '#555555' }}
            >
              {t('cards.plans.btnInsertPlanToPlanTableLegacy')}
            </IconButton>
          </CardPaper>
        </Grid>

      </Grid>

    </div>
  )
}

CardPlan.propTypes = {
  onSearch: PropTypes.func,
}

CardPlan.defaultProps = {
  onSearch: () => true
}

const styles = theme => ({
  header: {
    textAlign: 'center'
  },
  form: {
    display: 'flex',
    alignItems: 'center'
  },
  formField: {
    width: '100%',
    height: '100%'
  },
  gridItem: {
    display: 'flex',
    alignItems: 'flex-start'
  }
})

export default withStyles(styles)(CardPlan)